<template>
  <v-layout
    v-once
    column
  >
    <v-flex>
      <h2 class="display-3 display-3_dark my-4">
        {{ $t('warehouses.messages.will_table') }}
      </h2>
      <div v-if="regionalWarehouse">
        <h4 class="display-1 display-1_dark">
          {{ $t('warehouses.messages.adding_rejon_warehouse') }}
        </h4>
        <ul class="ul-decimal pl-3">
          <li
            v-for="(item, index) in rejonParameters"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
        <p class="fw-600 f-1 mt-4">
          {{ $t('warehouses.messages.example_rejon') }}
        </p>
        <v-alert
          :value="true"
          class="py-3 mb-4"
        >
          <v-layout align-center>
            <v-flex class="none-growth mr-2">
              <v-icon color="sz_red">
                error_outline
              </v-icon>
            </v-flex>
            <v-flex>
              <p class="ma-0">
                {{ $t('warehouses.messages.hint_1') }}
                <a
                  class="small"
                  :href="links.REJON_WAREHOUSE_STANDARDS"
                  target="_blank"
                >
                  {{ $t('warehouses.messages.hint_link_to_rejon') }}
                </a>
                {{ $t('warehouses.messages.hint_2_to_rejon') }}
              </p>
            </v-flex>
          </v-layout>
        </v-alert>
      </div>
      <div v-if="supportingWarehouse">
        <h4 class="display-1 display-1_dark">
          {{ $t('warehouses.messages.adding_supporting_warehouse') }}
        </h4>
        <ul class="ul-decimal pl-3">
          <li
            v-for="(item, index) in parameters"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
        <p class="fw-600 f-1 mt-4">
          {{ $t('warehouses.messages.example_supporting') }}
        </p>
        <v-alert
          :value="true"
          class="py-3"
        >
          <v-layout align-center>
            <v-flex class="none-growth mr-2">
              <v-icon color="sz_red">
                error_outline
              </v-icon>
            </v-flex>
            <v-flex>
              <p class="ma-0">
                {{ $t('warehouses.messages.hint_1') }}
                <a
                  class="small"
                  :href="links.SUPPORTING_WAREHOUSE_STANDARDS"
                  target="_blank"
                >
                  {{ $t('warehouses.messages.hint_link') }}
                </a>
                {{ $t('warehouses.messages.hint_2') }}
              </p>
            </v-flex>
          </v-layout>
        </v-alert>
      </div>
      <v-layout
        align-center
        class="my-4 text-dark"
      >
        <v-flex class="none-growth mr-2">
          <BaseIcon>
            <CalendarIcon />
          </BaseIcon>
        </v-flex>
        <v-flex>
          <p class="mb-0 f-1">
            {{ endAddingData }}
          </p>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import CalendarIcon from '@/icons/CalendarIcon';

import links from '@/constants/links';
import WAREHOUSE_TYPES from '@/constants/warehouse/warehouseType';

export default {
    name: 'AddWarehouseInfo',
    components: {
        BaseIcon,
        CalendarIcon
    },
    props: {
        warehouseType: {
            required: true,
            type: Number
        }
    },
    data () {
        return {
            links,
            friday: '',
            saturday: '',
            endAddingData: '',
            WAREHOUSE_TYPES
        };
    },
    computed: {
        resource () {
            return this.$store.getters['warehouses/getResource'];
        },
        dates () {
            return this.resource.find((el) => el.id === 1003);
        },
        lastData () {
            return this.resource.find((el) => el.id === 1004);
        },
        parameters () {
            const a = this.$t('warehouses.messages.parameters');
            const b = this.$t('warehouses.messages.other_parameters_supporting_warehouse');
            const c = {
                8:
          this.$t('warehouses.messages.last_parameter_supporting_warehouse.1') +
          ' ' +
          this.friday +
          ' ' +
          this.$t('warehouses.messages.last_parameter_supporting_warehouse.2') +
          ' ' +
          this.saturday
            };
            return { ...a, ...b, ...c };
        },
        rejonParameters () {
            const a = this.$t('warehouses.messages.parameters');
            const b = this.$t('warehouses.messages.other_parameters_rejon_warehouse');
            return { ...a, ...b };
        },
        regionalWarehouse () {
            return (
                this.warehouseType === this.WAREHOUSE_TYPES.REGIONAL ||
        this.warehouseType === this.WAREHOUSE_TYPES.BOTH
            );
        },
        supportingWarehouse () {
            return (
                this.warehouseType === this.WAREHOUSE_TYPES.SUPPORTING ||
        this.warehouseType === this.WAREHOUSE_TYPES.BOTH
            );
        }
    },
    watch: {
        dates: {
            handler (val) {
                this.friday = this.getDate(val.resources.find((el) => el.id === 327).description);
                this.saturday = this.getDate(val.resources.find((el) => el.id === 328).description);
            },
            immediate: true
        },
        lastData: {
            handler (val) {
                this.endAddingData =
          val.description + ' ' + val.resources.find((el) => el.id === 330).description;
            },
            immediate: true
        }
    },
    methods: {
        getDate (resourceDate) {
            const startIndexOfDate = 0;
            const endIndexOfDate = resourceDate.indexOf('(') - 1;
            return resourceDate.slice(startIndexOfDate, endIndexOfDate);
        }
    }
};
</script>

<style scoped></style>
